import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = (showDrawer: boolean) =>
  makeStyles((theme: Theme) => ({
    topLink: {
      minHeight: "3rem",
    },
    dropdownLink: {
      paddingLeft: theme.spacing(10),
    },
    selectedLink: {
      background: theme.palette.primary.main,
    },
    link: {
      textDecoration: "none",
      color: theme.palette.common.white,
      "& .MuiTypography-root": {
        fontSize: "0.875rem",
      },
      borderRadius: theme.spacing(1),
    },
    listIcon: {
      color: theme.palette.common.white,
      minWidth: showDrawer ? "2.8rem" : "auto",
      paddingLeft: showDrawer ? "1.5rem" : 0,
      justifyContent: showDrawer ? "flex-start" : "center",
      display: "flex",
      alignItems: "center",
      marginRight: showDrawer ? theme.spacing(2) : 0,
      [theme.breakpoints.up("md")]: {
        paddingLeft: showDrawer ? "1.2rem" : 0,
      },
      [theme.breakpoints.down("md")]: {
        paddingLeft: showDrawer ? "0.75rem" : 0,
      },
    },
    listText: {
      display: "block",
      color: theme.palette.common.white,
    },
    listIconWidth: {
      minWidth: 0,
    },
    arrowIcon: {
      color: theme.palette.common.white,
      justifyContent: "center",
    },
  }));

export default useStyles;
